import React from "react";

type HighlightLastWordProps = {
  title?: string;
};

export default function highlightLastWord({
  title,
}: HighlightLastWordProps): React.ReactNode {
  if (!title) return null;

  const match = title.match(/^(.*?)([_\s][^_\s]+)$/);

  if (!match) {
    return title;
  }

  const firstPart = match[1];
  const lastPart = match[2];

  return React.createElement(
    React.Fragment,
    null,
    firstPart,
    React.createElement(
      "span",
      { className: "text-[#00638A] font-bold" },
      lastPart
    )
  );
}
